webpackJsonp([1,2],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(7)

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(3),
  /* template */
  __webpack_require__(12),
  /* scopeId */
  "data-v-52aa5f48",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_currency_formatter__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_currency_formatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_currency_formatter__);




/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      basicFee: 8910,
      expressFee: 5810,
      buyTwoWayTicket: true,
      useTwoWayDiscount: false,
      useStudentDiscount: false,
      twoWayDiscountCheck1: false,
      twoWayDiscountCheck2: false,
      studentDiscountCheck1: false,
      studentDiscountCheck2: false,
      studentDiscountCheck3: false
    };
  },

  watch: {
    buyTwoWayTicket: function buyTwoWayTicket() {
      if (this.buyTwoWayTicket === false) {
        this.useTwoWayDiscount = false;
      }
    },
    useTwoWayDiscount: function useTwoWayDiscount() {
      if (this.useTwoWayDiscount === false) {
        this.twoWayDiscountCheck1 = false;
        this.twoWayDiscountCheck2 = false;
      }
    },
    useStudentDiscount: function useStudentDiscount() {
      if (this.useStudentDiscount === false) {
        this.studentDiscountCheck1 = false;
        this.studentDiscountCheck2 = false;
        this.studentDiscountCheck3 = false;
      }
    }
  },
  computed: {
    showWarning: function showWarning() {
      return this.isTwoWayDiscountInvalid || this.isStudentDiscountInvalid;
    },
    isTwoWayDiscountInvalid: function isTwoWayDiscountInvalid() {
      return this.useTwoWayDiscount && !(this.twoWayDiscountCheck1 && this.twoWayDiscountCheck2);
    },
    isStudentDiscountInvalid: function isStudentDiscountInvalid() {
      return this.useStudentDiscount && !(this.studentDiscountCheck1 && this.studentDiscountCheck2 && this.studentDiscountCheck3);
    },
    formula: function formula() {
      var result = this.basicFee.toString();
      if (this.useTwoWayDiscount) {
        result += ' * 0.9';
      }
      if (this.useStudentDiscount) {
        result += ' * 0.8';
      }
      if (this.expressFee > 0) {
        result += ' + ' + this.expressFee.toString();
      }
      result = 'floor10(' + result + ')';
      if (this.buyTwoWayTicket) {
        result += ' * 2';
      }
      return result;
    },
    amount: function amount() {
      var result = this.basicFee;
      if (this.useTwoWayDiscount) {
        result *= 0.9;
      }
      if (this.useStudentDiscount) {
        result *= 0.8;
      }
      if (this.expressFee > 0) {
        result += this.expressFee;
      }
      result = this.floor10(result);
      if (this.buyTwoWayTicket) {
        result *= 2;
      }
      return __WEBPACK_IMPORTED_MODULE_0_currency_formatter___default.a.format(result, { locale: 'ja-JP' });
    }
  },
  methods: {
    floor10: function floor10(value) {
      return Math.floor(value / 10) * 10;
    }
  }
};

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = {
	"AED": {
		"code": "AED",
		"symbol": "د.إ.‏",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"AFN": {
		"code": "AFN",
		"symbol": "؋",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"ALL": {
		"code": "ALL",
		"symbol": "Lek",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"AMD": {
		"code": "AMD",
		"symbol": "֏",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"ANG": {
		"code": "ANG",
		"symbol": "ƒ",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"AOA": {
		"code": "AOA",
		"symbol": "Kz",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"ARS": {
		"code": "ARS",
		"symbol": "$",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"AUD": {
		"code": "AUD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"AWG": {
		"code": "AWG",
		"symbol": "ƒ",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"AZN": {
		"code": "AZN",
		"symbol": "₼",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"BAM": {
		"code": "BAM",
		"symbol": "КМ",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"BBD": {
		"code": "BBD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"BDT": {
		"code": "BDT",
		"symbol": "৳",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 0
	},
	"BGN": {
		"code": "BGN",
		"symbol": "лв.",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"BHD": {
		"code": "BHD",
		"symbol": "د.ب.‏",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 3
	},
	"BIF": {
		"code": "BIF",
		"symbol": "FBu",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 0
	},
	"BMD": {
		"code": "BMD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"BND": {
		"code": "BND",
		"symbol": "$",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 0
	},
	"BOB": {
		"code": "BOB",
		"symbol": "Bs",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"BRL": {
		"code": "BRL",
		"symbol": "R$",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"BSD": {
		"code": "BSD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"BTC": {
		"code": "BTC",
		"symbol": "Ƀ",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"BTN": {
		"code": "BTN",
		"symbol": "Nu.",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 1
	},
	"BWP": {
		"code": "BWP",
		"symbol": "P",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"BYR": {
		"code": "BYR",
		"symbol": "р.",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"BZD": {
		"code": "BZD",
		"symbol": "BZ$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"CAD": {
		"code": "CAD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"CDF": {
		"code": "CDF",
		"symbol": "FC",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"CHF": {
		"code": "CHF",
		"symbol": "CHF",
		"thousandsSeparator": "'",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"CLP": {
		"code": "CLP",
		"symbol": "$",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"CNY": {
		"code": "CNY",
		"symbol": "¥",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"COP": {
		"code": "COP",
		"symbol": "$",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"CRC": {
		"code": "CRC",
		"symbol": "₡",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"CUC": {
		"code": "CUC",
		"symbol": "CUC",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"CUP": {
		"code": "CUP",
		"symbol": "$MN",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"CVE": {
		"code": "CVE",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"CZK": {
		"code": "CZK",
		"symbol": "Kč",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"DJF": {
		"code": "DJF",
		"symbol": "Fdj",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 0
	},
	"DKK": {
		"code": "DKK",
		"symbol": "kr.",
		"thousandsSeparator": "",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"DOP": {
		"code": "DOP",
		"symbol": "RD$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"DZD": {
		"code": "DZD",
		"symbol": "د.ج.‏",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"EGP": {
		"code": "EGP",
		"symbol": "ج.م.‏",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"ERN": {
		"code": "ERN",
		"symbol": "Nfk",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"ETB": {
		"code": "ETB",
		"symbol": "ETB",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"EUR": {
		"code": "EUR",
		"symbol": "€",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"FJD": {
		"code": "FJD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"FKP": {
		"code": "FKP",
		"symbol": "£",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"GBP": {
		"code": "GBP",
		"symbol": "£",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"GEL": {
		"code": "GEL",
		"symbol": "Lari",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"GHS": {
		"code": "GHS",
		"symbol": "₵",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"GIP": {
		"code": "GIP",
		"symbol": "£",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"GMD": {
		"code": "GMD",
		"symbol": "D",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"GNF": {
		"code": "GNF",
		"symbol": "FG",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 0
	},
	"GTQ": {
		"code": "GTQ",
		"symbol": "Q",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"GYD": {
		"code": "GYD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"HKD": {
		"code": "HKD",
		"symbol": "HK$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"HNL": {
		"code": "HNL",
		"symbol": "L.",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"HRK": {
		"code": "HRK",
		"symbol": "kn",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"HTG": {
		"code": "HTG",
		"symbol": "G",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"HUF": {
		"code": "HUF",
		"symbol": "Ft",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"IDR": {
		"code": "IDR",
		"symbol": "Rp",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 0
	},
	"ILS": {
		"code": "ILS",
		"symbol": "₪",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"INR": {
		"code": "INR",
		"symbol": "₹",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"IQD": {
		"code": "IQD",
		"symbol": "د.ع.‏",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"IRR": {
		"code": "IRR",
		"symbol": "﷼",
		"thousandsSeparator": ",",
		"decimalSeparator": "/",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"ISK": {
		"code": "ISK",
		"symbol": "kr.",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 0
	},
	"JMD": {
		"code": "JMD",
		"symbol": "J$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"JOD": {
		"code": "JOD",
		"symbol": "د.ا.‏",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 3
	},
	"JPY": {
		"code": "JPY",
		"symbol": "¥",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 0
	},
	"KES": {
		"code": "KES",
		"symbol": "S",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"KGS": {
		"code": "KGS",
		"symbol": "сом",
		"thousandsSeparator": " ",
		"decimalSeparator": "-",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"KHR": {
		"code": "KHR",
		"symbol": "៛",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 0
	},
	"KMF": {
		"code": "KMF",
		"symbol": "CF",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"KPW": {
		"code": "KPW",
		"symbol": "₩",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 0
	},
	"KRW": {
		"code": "KRW",
		"symbol": "₩",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 0
	},
	"KWD": {
		"code": "KWD",
		"symbol": "د.ك.‏",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 3
	},
	"KYD": {
		"code": "KYD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"KZT": {
		"code": "KZT",
		"symbol": "₸",
		"thousandsSeparator": " ",
		"decimalSeparator": "-",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"LAK": {
		"code": "LAK",
		"symbol": "₭",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 0
	},
	"LBP": {
		"code": "LBP",
		"symbol": "ل.ل.‏",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"LKR": {
		"code": "LKR",
		"symbol": "₨",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 0
	},
	"LRD": {
		"code": "LRD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"LSL": {
		"code": "LSL",
		"symbol": "M",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"LYD": {
		"code": "LYD",
		"symbol": "د.ل.‏",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 3
	},
	"MAD": {
		"code": "MAD",
		"symbol": "د.م.‏",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"MDL": {
		"code": "MDL",
		"symbol": "lei",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"MGA": {
		"code": "MGA",
		"symbol": "Ar",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 0
	},
	"MKD": {
		"code": "MKD",
		"symbol": "ден.",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"MMK": {
		"code": "MMK",
		"symbol": "K",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"MNT": {
		"code": "MNT",
		"symbol": "₮",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"MOP": {
		"code": "MOP",
		"symbol": "MOP$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"MRO": {
		"code": "MRO",
		"symbol": "UM",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"MTL": {
		"code": "MTL",
		"symbol": "₤",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"MUR": {
		"code": "MUR",
		"symbol": "₨",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"MVR": {
		"code": "MVR",
		"symbol": "MVR",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 1
	},
	"MWK": {
		"code": "MWK",
		"symbol": "MK",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"MXN": {
		"code": "MXN",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"MYR": {
		"code": "MYR",
		"symbol": "RM",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"MZN": {
		"code": "MZN",
		"symbol": "MT",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 0
	},
	"NAD": {
		"code": "NAD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"NGN": {
		"code": "NGN",
		"symbol": "₦",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"NIO": {
		"code": "NIO",
		"symbol": "C$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"NOK": {
		"code": "NOK",
		"symbol": "kr",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"NPR": {
		"code": "NPR",
		"symbol": "₨",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"NZD": {
		"code": "NZD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"OMR": {
		"code": "OMR",
		"symbol": "﷼",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 3
	},
	"PAB": {
		"code": "PAB",
		"symbol": "B/.",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"PEN": {
		"code": "PEN",
		"symbol": "S/.",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"PGK": {
		"code": "PGK",
		"symbol": "K",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"PHP": {
		"code": "PHP",
		"symbol": "₱",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"PKR": {
		"code": "PKR",
		"symbol": "₨",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"PLN": {
		"code": "PLN",
		"symbol": "zł",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"PYG": {
		"code": "PYG",
		"symbol": "₲",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"QAR": {
		"code": "QAR",
		"symbol": "﷼",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"RON": {
		"code": "RON",
		"symbol": "lei",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"RSD": {
		"code": "RSD",
		"symbol": "Дин.",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"RUB": {
		"code": "RUB",
		"symbol": "₽",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"RWF": {
		"code": "RWF",
		"symbol": "RWF",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"SAR": {
		"code": "SAR",
		"symbol": "﷼",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"SBD": {
		"code": "SBD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"SCR": {
		"code": "SCR",
		"symbol": "₨",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"SDD": {
		"code": "SDD",
		"symbol": "LSd",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"SDG": {
		"code": "SDG",
		"symbol": "£‏",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"SEK": {
		"code": "SEK",
		"symbol": "kr",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"SGD": {
		"code": "SGD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"SHP": {
		"code": "SHP",
		"symbol": "£",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"SLL": {
		"code": "SLL",
		"symbol": "Le",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"SOS": {
		"code": "SOS",
		"symbol": "S",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"SRD": {
		"code": "SRD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"STD": {
		"code": "STD",
		"symbol": "Db",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"SVC": {
		"code": "SVC",
		"symbol": "₡",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"SYP": {
		"code": "SYP",
		"symbol": "£",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"SZL": {
		"code": "SZL",
		"symbol": "E",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"THB": {
		"code": "THB",
		"symbol": "฿",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"TJS": {
		"code": "TJS",
		"symbol": "TJS",
		"thousandsSeparator": " ",
		"decimalSeparator": ";",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"TMT": {
		"code": "TMT",
		"symbol": "m",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 0
	},
	"TND": {
		"code": "TND",
		"symbol": "د.ت.‏",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 3
	},
	"TOP": {
		"code": "TOP",
		"symbol": "T$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"TRY": {
		"code": "TRY",
		"symbol": "TL",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"TTD": {
		"code": "TTD",
		"symbol": "TT$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"TVD": {
		"code": "TVD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"TWD": {
		"code": "TWD",
		"symbol": "NT$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"TZS": {
		"code": "TZS",
		"symbol": "TSh",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"UAH": {
		"code": "UAH",
		"symbol": "₴",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"UGX": {
		"code": "UGX",
		"symbol": "USh",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"USD": {
		"code": "USD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"UYU": {
		"code": "UYU",
		"symbol": "$U",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"UZS": {
		"code": "UZS",
		"symbol": "сўм",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"VEB": {
		"code": "VEB",
		"symbol": "Bs.",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"VEF": {
		"code": "VEF",
		"symbol": "Bs. F.",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"VND": {
		"code": "VND",
		"symbol": "₫",
		"thousandsSeparator": ".",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 1
	},
	"VUV": {
		"code": "VUV",
		"symbol": "VT",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 0
	},
	"WST": {
		"code": "WST",
		"symbol": "WS$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"XAF": {
		"code": "XAF",
		"symbol": "F",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"XCD": {
		"code": "XCD",
		"symbol": "$",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"XOF": {
		"code": "XOF",
		"symbol": "F",
		"thousandsSeparator": " ",
		"decimalSeparator": ",",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"XPF": {
		"code": "XPF",
		"symbol": "F",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": false,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"YER": {
		"code": "YER",
		"symbol": "﷼",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"ZAR": {
		"code": "ZAR",
		"symbol": "R",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": true,
		"decimalDigits": 2
	},
	"ZMW": {
		"code": "ZMW",
		"symbol": "ZK",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	},
	"WON": {
		"code": "WON",
		"symbol": "₩",
		"thousandsSeparator": ",",
		"decimalSeparator": ".",
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"decimalDigits": 2
	}
};

/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports) {

module.exports = {
	"de-AT": {
		"thousandsSeparator": "."
	},
	"el-GR": {
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"thousandsSeparator": "."
	},
	"en-IE": {
		"symbolOnLeft": true,
		"thousandsSeparator": ","
	},
	"es-ES": {
		"thousandsSeparator": "."
	},
	"it-IT": {
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"thousandsSeparator": "."
	},
	"nl-NL": {
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"thousandsSeparator": "."
	},
	"nl-BE": {
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"thousandsSeparator": "."
	},
	"ko-KR": {
		"symbolOnLeft": true,
		"spaceBetweenAmountAndSymbol": false,
		"thousandsSeparator": "."
	}
};

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("JRの割引計算機")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("運賃（円）")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.basicFee),
      expression: "basicFee",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.basicFee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.basicFee = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("特急料金（円）")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.expressFee),
      expression: "expressFee",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.expressFee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.expressFee = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.buyTwoWayTicket),
      expression: "buyTwoWayTicket"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.buyTwoWayTicket) ? _vm._i(_vm.buyTwoWayTicket, null) > -1 : (_vm.buyTwoWayTicket)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.buyTwoWayTicket,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.buyTwoWayTicket = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.buyTwoWayTicket = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.buyTwoWayTicket = $$c
        }
      }
    }
  }), _vm._v("\n      往復切符を買う\n    ")]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buyTwoWayTicket),
      expression: "buyTwoWayTicket"
    }]
  }, [_c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.useTwoWayDiscount),
      expression: "useTwoWayDiscount"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.useTwoWayDiscount) ? _vm._i(_vm.useTwoWayDiscount, null) > -1 : (_vm.useTwoWayDiscount)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.useTwoWayDiscount,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.useTwoWayDiscount = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.useTwoWayDiscount = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.useTwoWayDiscount = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'text-danger': _vm.isTwoWayDiscountInvalid
    }
  }, [_vm._v("\n            往復割を使う\n          ")])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.useTwoWayDiscount),
      expression: "useTwoWayDiscount"
    }]
  }, [_c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.twoWayDiscountCheck1),
      expression: "twoWayDiscountCheck1"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.twoWayDiscountCheck1) ? _vm._i(_vm.twoWayDiscountCheck1, null) > -1 : (_vm.twoWayDiscountCheck1)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.twoWayDiscountCheck1,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.twoWayDiscountCheck1 = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.twoWayDiscountCheck1 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.twoWayDiscountCheck1 = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'text-danger': !_vm.twoWayDiscountCheck1
    }
  }, [_vm._v("\n                片道601km以上である（東京ー大阪間は不可）\n              ")])])]), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.twoWayDiscountCheck2),
      expression: "twoWayDiscountCheck2"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.twoWayDiscountCheck2) ? _vm._i(_vm.twoWayDiscountCheck2, null) > -1 : (_vm.twoWayDiscountCheck2)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.twoWayDiscountCheck2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.twoWayDiscountCheck2 = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.twoWayDiscountCheck2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.twoWayDiscountCheck2 = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'text-danger': !_vm.twoWayDiscountCheck2
    }
  }, [_vm._v("\n                乗車券の有効日数を超える場合は往復切符を買うことができないことを知っている"), _c('br'), _vm._v("\n                （"), _c('a', {
    attrs: {
      "href": "https://www.jreast.co.jp/kippu/04.html"
    }
  }, [_vm._v("乗車券の有効期間｜きっぷのルール：JRおでかけネット")]), _vm._v("）\n              ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.useStudentDiscount),
      expression: "useStudentDiscount"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.useStudentDiscount) ? _vm._i(_vm.useStudentDiscount, null) > -1 : (_vm.useStudentDiscount)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.useStudentDiscount,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.useStudentDiscount = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.useStudentDiscount = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.useStudentDiscount = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'text-danger': _vm.isStudentDiscountInvalid
    }
  }, [_vm._v("\n        学割を使う\n      ")])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.useStudentDiscount),
      expression: "useStudentDiscount"
    }]
  }, [_c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.studentDiscountCheck1),
      expression: "studentDiscountCheck1"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.studentDiscountCheck1) ? _vm._i(_vm.studentDiscountCheck1, null) > -1 : (_vm.studentDiscountCheck1)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.studentDiscountCheck1,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.studentDiscountCheck1 = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.studentDiscountCheck1 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.studentDiscountCheck1 = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'text-danger': !_vm.studentDiscountCheck1
    }
  }, [_vm._v("\n            片道101km以上である\n          ")])])]), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.studentDiscountCheck2),
      expression: "studentDiscountCheck2"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.studentDiscountCheck2) ? _vm._i(_vm.studentDiscountCheck2, null) > -1 : (_vm.studentDiscountCheck2)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.studentDiscountCheck2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.studentDiscountCheck2 = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.studentDiscountCheck2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.studentDiscountCheck2 = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'text-danger': !_vm.studentDiscountCheck2
    }
  }, [_vm._v("\n            乗車券の有効日数を超える場合は往復切符を買うことができないので，往路と復路で学割証が2枚必要なことを知っている"), _c('br'), _vm._v("\n            （"), _c('a', {
    attrs: {
      "href": "https://www.jreast.co.jp/kippu/04.html"
    }
  }, [_vm._v("乗車券の有効期間｜きっぷのルール：JRおでかけネット")]), _vm._v("）\n          ")])])]), _vm._v(" "), _c('li', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.studentDiscountCheck3),
      expression: "studentDiscountCheck3"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.studentDiscountCheck3) ? _vm._i(_vm.studentDiscountCheck3, null) > -1 : (_vm.studentDiscountCheck3)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.studentDiscountCheck3,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.studentDiscountCheck3 = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.studentDiscountCheck3 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.studentDiscountCheck3 = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'text-danger': !_vm.studentDiscountCheck3
    }
  }, [_vm._v("\n            大都市近郊区間では往復券は発売当日のみ有効で，日が変わる場合には往路と復路で学割証が2枚必要なことを知っている"), _c('br'), _vm._v("  \n            （"), _c('a', {
    attrs: {
      "href": "https://www.jr-odekake.net/railroad/ticket/guide/02b.html#5"
    }
  }, [_vm._v("大都市近郊区間内のみをご利用になる場合の特例｜きっぷのルール：JRおでかけネット")]), _vm._v("）\n          ")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showWarning),
      expression: "showWarning"
    }],
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("チェックボックスを確認してください")]), _vm._v(" "), _c('b', [_vm._v("結果")]), _vm._v(" " + _vm._s(_vm.formula) + " = " + _vm._s(_vm.amount) + "\n")])
},staticRenderFns: []}

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__app__);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#vue-root',
  template: '<app></app>',
  components: { app: __WEBPACK_IMPORTED_MODULE_1__app___default.a }
});

/***/ })
],[15]);


// WEBPACK FOOTER //
// static/js/app.49397b138f2547295b16.js